import axios from "@/axios.js";
// Assuming constants.apiUrl points to your Python FastAPI (e.g., http://localhost:8000)
import constants from "@/constants.js"; 

export default {
  // 1. Change parameter from userId to userEmail
  async getCoachUserData({ commit }, userEmail) { 
    try {
      // 2. Point to the new FastAPI Python endpoint we just created
      const resObj = await axios.get(
        `https://api.coach.getboarded.com/user-quest/${userEmail}` // Adjust port 8000 if your FastAPI runs on a different port
      );
      
      commit("SET_COACH_DATA", resObj.data.data);
      return resObj.data.data;
    } catch (error) {
      console.error("Failed to fetch quest data:", error);
      throw error;
    }
  },
};